import type { ReactNode } from "react";
import { useState } from "react";
import * as HoverCard from "@radix-ui/react-hover-card";
import { CardContent } from "./CardContent";

export interface ProfileHoverCardProps {
  avatarURL?: string;
  children: ReactNode;
  communityMemberId: number | string;
  disabled?: boolean;
  headline?: string;
  messagingEnabled?: boolean;
  name?: string;
  publicUid?: string;
  side?: "top" | "right";
  sideOffset?: number;
}

export const ProfileHoverCard = ({
  children,
  communityMemberId,
  publicUid,
  messagingEnabled,
  avatarURL,
  name = "",
  headline = "",
  disabled = false,
  side = "right",
  sideOffset = 5,
}: ProfileHoverCardProps) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  return (
    <HoverCard.Root
      openDelay={300}
      closeDelay={100}
      open={isOpen}
      onOpenChange={setIsOpen}
    >
      <HoverCard.Trigger asChild>
        <span>{children}</span>
      </HoverCard.Trigger>
      <HoverCard.Portal>
        {!disabled && (
          <CardContent
            communityMemberId={communityMemberId}
            publicUid={publicUid}
            avatarURL={avatarURL}
            name={name}
            headline={headline}
            messagingEnabled={messagingEnabled}
            closeCard={() => setIsOpen(false)}
            side={side}
            sideOffset={sideOffset}
          />
        )}
      </HoverCard.Portal>
    </HoverCard.Root>
  );
};
